import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { ForwardConversationMessage200Response } from '@nora-monorepo/nora-api-client';
import { appLogger, useApiStore } from '@nora-monorepo/ui-shared';

export const useForwardMessageStore = defineStore('forwardMessageStore', () => {
  const showForwardMessageModal = ref(false);
  const conversationId = ref('');
  const messageId = ref('');
  const isSending = ref(false);

  const api = useApiStore();

  function openForwardMessageModal(newConversationId = '', newMessageId = ''): void {
    conversationId.value = newConversationId;
    messageId.value = newMessageId;
    showForwardMessageModal.value = true;
  }

  async function forwardMessages(ids: string[]): Promise<ForwardConversationMessage200Response | undefined> {
    if (!conversationId.value || !messageId.value) {
      return;
    }

    isSending.value = true;

    try {
      return await api.unwrap(
        api.conversationMessage.forwardConversationMessage({
          conversationId: conversationId.value,
          messageId: messageId.value,
          messageForwardPayload: {
            conversations: ids,
          },
        }),
      );
    }
    catch (error) {
      appLogger.error({
        message: 'Could not forward chat message',
        context: { conversationId: conversationId.value, messageId: messageId.value },
        sensitiveContext: { error },
      });
      throw error;
    }
    finally {
      isSending.value = false;
    }
  }

  return {
    showForwardMessageModal,
    conversationId,
    messageId,
    isSending,

    openForwardMessageModal,
    forwardMessages,
  };
});
